import React from 'react';

import {
  Card,
  CardHeader,
  CloseIcon,
  Grid,
  IconButton,
} from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  loadAdditionalRewardConditions,
  loadRewardPackages,
} from '../../../sources/fields';
import {
  ADDITIONAL_REWARD_CONDITION,
  ADDITIONAL_REWARD_PACKAGE,
  DEPENDENCIES,
} from '../constants';

const AdditionalReward = ({
  disabled,
  onRemove,
  isConditionDisabled,
  rewardPackageLabel,
  rewardConditionLabel,
}) => {
  return (
    <Card elevation={6}>
      <CardHeader
        action={
          <IconButton
            icon={<CloseIcon />}
            tooltip={'Remove'}
            onClick={onRemove}
          />
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormField.Select
              label={rewardPackageLabel}
              padding={0}
              name={ADDITIONAL_REWARD_PACKAGE}
              source={loadRewardPackages}
              lazy={true}
              disabled={disabled}
              depends={DEPENDENCIES[ADDITIONAL_REWARD_PACKAGE]}
            />
          </Grid>
          <Grid item xs={6}>
            <FormField.Select
              label={rewardConditionLabel}
              padding={0}
              name={ADDITIONAL_REWARD_CONDITION}
              source={loadAdditionalRewardConditions}
              lazy={true}
              disabled={disabled}
              depends={DEPENDENCIES[ADDITIONAL_REWARD_CONDITION]}
              isOptionDisabled={isConditionDisabled}
            />
          </Grid>
        </Grid>
      </CardHeader>
    </Card>
  );
};
export default AdditionalReward;
